import Shared from "emun.cart/cart.controller";
import resolve from "ioc/resolve";
import templateUrl from "emun.cart/payfabric/cart-creditcard-payfabric.htm";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";
import cartConfig from "emun.cart/cart.config";

export class CartCreditCardPayfabricController extends Shared {
	constructor($cart, $scope, $sce, $rootScope) {
		super($cart, $scope, $sce);
		let $stateParams = resolve("$stateParams");
		if ($stateParams.cartId) $cart.load($stateParams.cartId);
		let $ctrl = this;
		$ctrl.bus = new ServiceBus;
		$ctrl.cartConfig = cartConfig;
		let retailerId = $ctrl.retailerId || $ctrl.$cart.retailerId;
		let vendorCustId = $ctrl.$cart.vendorCustomerId || $ctrl.retailerId || $ctrl.$cart.retailerId;
		let returnUri = $ctrl.returnUri;
		if (!$cart.vendorCustomerId) {
			$cart.applyPaymentTerms({paymentTermsId: "Pending Card"}).then(function() {
			  $cart.load($stateParams.cartId);
			});
		}
		$ctrl.bus.send("PayFabric/GetToken.json").then(function(res) {
			if (res.data) {
				$ctrl.token = res.data;
				$ctrl.bus
				.send("QueryRetailers.json?Id=" + retailerId)
				.then(function (response) {
					if (response.data.results.length > 0) {
						$ctrl.retailer = response.data.results[0];
						var url = $ctrl.cartConfig.payfabricWalletPage + vendorCustId + "&token=" + $ctrl.token;
						if ($ctrl.$cart.billingLocation) {
							if ($ctrl.$cart.billingLocation.address) url = url + "&Street1=" + $ctrl.$cart.billingLocation.address;
							if ($ctrl.$cart.billingLocation.city) url = url + "&City=" + $ctrl.$cart.billingLocation.city;
							if ($ctrl.$cart.billingLocation.state) url = url + "&State=" + $ctrl.$cart.billingLocation.state;
							if ($ctrl.$cart.billingLocation.zip) url = url + "&Zip=" + $ctrl.$cart.billingLocation.zip;
							if ($ctrl.$cart.billingLocation.country) url = url + "&Country=" + $ctrl.$cart.billingLocation.country;
						} else if ($ctrl.retailer.billingLocadtion) {
							if ($ctrl.retailer.billingLocation.address) url = url + "&Street1=" + $ctrl.retailer.billingLocation.address;
							if ($ctrl.retailer.billingLocation.city) url = url + "&City=" + $ctrl.retailer.billingLocation.city;
							if ($ctrl.retailer.billingLocation.state) url = url + "&State=" + $ctrl.retailer.billingLocation.state;
							if ($ctrl.retailer.billingLocation.zip) url = url + "&Zip=" + $ctrl.retailer.billingLocation.zip;
							if ($ctrl.retailer.billingLocation.country) url = url + "&Country=" + $ctrl.retailer.billingLocation.country;
						}
						$ctrl.payfabricWalletPage = $sce.trustAsResourceUrl(url);
					}
				});
	
			}
		});
		window.addEventListener('message', $ctrl.cardEntered, false);
	}
	cardEntered(e) {
		const $ctrl = this;
		let $rootScope = resolve("$rootScope");
		if (e.data != null && e.data != 'undefined') {
			//handle wallet response
			const obj = JSON.parse(e.data);
			if (obj != null) {
				if (obj.Event == 'OnWalletUpdateCompleted') {
					var result = obj.Result;
					if (result != null && result === true) {
						var CardID = obj.ID;
					}
				} else if (obj.Event == 'OnWalletCreateCompleted') {
					var CardID = obj.ID;
					if (CardID != null) {
						$rootScope.$broadcast("creditCardCreated", obj);
					}
				}
				// else if (obj.Event == 'OnTransactionCompleted' || obj.Event == 'successCallback') {
				// 	var trxkey = obj.TrxKey;
				// 	if (trxkey != null && trxkey != '') {
				// 		var RespStatus = obj.RespStatus;
				// 		var mgs = "trxkey: " + trxkey + " ,RespStatus:" + RespStatus + "ResultCode:" + obj.ResultCode + "TrxDate:" + obj.TrxDate + "TrxDateUTC:" + obj.TrxDateUTC + "RespTrxTag:" + obj.RespTrxTag;
				// 		console.debug("BL*** card results", mgs);
				// 	}
				// }
			}
		}
   }
}

export default {
	bindings: {
		retailerId: "@",
		returnUri: "@"
	},
	controller: CartCreditCardPayfabricController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};
